<template>
  <div class="fixed-center text-center" style="width: 80%">
    <p>
      <img src="../assets/retail_order_placed.jpg" style="width:30vw;max-width:250px;" >
    </p>
    <p>That’s a sweet collection you’ve got there!</p>
    <p>We’ll get cracking on packaging these beauties up & send your way.</p>
    <p>You can check back on your <a :href="`/#/account/orders/retail/${$route.params.id}`">order history</a> at any time.</p>
    <p>Or <a href="https://climbicp.com.au/category/blog" target="_blank">click here</a> to view our resources hub for some wicked supporting info.</p>
    <p>We can’t wait to see what you create in climbing. So please share some love on Facebook or Instagram & tag us <a href="https://www.instagram.com/climbicp/" target="_blank">@climbicp</a></p>
    <p>Happy Climbing,</p>
    <p class="text-bold">Rob and the ICP team</p>
    <br>
    <p>
      <a href="https://www.facebook.com/climbicp" target="_blank"><img src="../assets/facebook.png"  style="width:30vw;max-width:40px;" ></a>&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://www.instagram.com/climbicp" target="_blank"><img src="../assets/instagram.png" style="width:30vw;max-width:40px;" ></a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Test'
}
</script>

